import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// ── Translation imports ───────────────────────────────────────────────────
import esCommon from './locales/es/common.json';
import esAuth from './locales/es/auth.json';
import esSis from './locales/es/sis.json';
import esCap from './locales/es/cap.json';
import esNotifications from './locales/es/notifications.json';
import esOnboarding from './locales/es/onboarding.json';
import esSetup from './locales/es/setup.json';
import esPlatform from './locales/es/platform.json';
import esMembership from './locales/es/membership.json';

import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enSis from './locales/en/sis.json';
import enCap from './locales/en/cap.json';
import enNotifications from './locales/en/notifications.json';
import enOnboarding from './locales/en/onboarding.json';
import enSetup from './locales/en/setup.json';
import enPlatform from './locales/en/platform.json';
import enMembership from './locales/en/membership.json';
import { storedExplicitLanguage } from './initial-language';

const initialLanguage = storedExplicitLanguage();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        common: esCommon,
        auth: esAuth,
        sis: esSis,
        cap: esCap,
        notifications: esNotifications,
        onboarding: esOnboarding,
        setup: esSetup,
        platform: esPlatform,
        membership: esMembership,
      },
      en: {
        common: enCommon,
        auth: enAuth,
        sis: enSis,
        cap: enCap,
        notifications: enNotifications,
        onboarding: enOnboarding,
        setup: enSetup,
        platform: enPlatform,
        membership: enMembership,
      },
    },
    // Con una elección explícita guardada, se arranca en ESE idioma: el primer
    // render ya sale bien, en el panel y en el portal (initial-language.ts).
    ...(initialLanguage ? { lng: initialLanguage } : {}),
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],
    defaultNS: 'common',
    ns: [
      'common',
      'auth',
      'sis',
      'cap',
      'notifications',
      'onboarding',
      'setup',
      'platform',
      'membership',
    ],
    interpolation: { escapeValue: false },

    // ── Claves faltantes: RUIDOSAS en desarrollo, BENIGNAS en producción ────
    // Por defecto i18next devuelve LA CLAVE cuando no la encuentra, así que un
    // error de validación sin traducir mostraría "validation.too_small.string"
    // en pantalla. Antes de esto no había ninguna configuración: el default
    // silencioso estaba activo y nadie lo había notado.
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: (_lngs, ns, key) => {
      if (import.meta.env.DEV) {
        // Ruidoso a propósito: una clave faltante es un bug de la traducción, y
        // en desarrollo tiene que doler antes de llegar a un usuario.
        console.error(`[i18n] clave faltante: ${ns}:${key}`);
      }
    },
    parseMissingKeyHandler: (key) => {
      if (import.meta.env.DEV) return `⚠️ ${key}`;
      // En producción, jamás la clave cruda en pantalla.
      return 'Revisa los datos ingresados.';
    },
    detection: {
      // Don't use browser language detector — we control language via uiStore
      order: [],
    },
  });

export default i18n;
